import React, { useState } from 'react';
import './klienciStyle/OknoEdycji.css'

const OknoEdycji = ({ children, isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className='window'>
            <div className='window_container'>
                {children}
            <button onClick={onClose} className='close-button'>X</button>
            </div>
        </div>
    );
};

export default OknoEdycji;
